import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaHeart } from "react-icons/fa";
import { removeFavorite } from "../../Redux/Cart_System";
import "../../Styles/WishList.css";
import Header from "../Components/Header";

const WishList = () => {
  const { favorites } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const handleRemoveFavorite = (id) => {
    dispatch(removeFavorite(id));
  };

  return (
    <>
      
      <div className="wishlist-container">
        <h2 className="wishlist-title">Your Favorites</h2>
        {favorites.length === 0 ? (
          <p className="wishlist-empty">
            No favorites yet. Start adding your favorite products!
          </p>
        ) : (
          <div className="wishlist-grid">
            {favorites.map((item) => (
              <div key={item.id} className="wishlist-card">
                <div className="wishlist-image-container">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="wishlist-image"
                  />
                  <FaHeart
                    className="wishlist-heart"
                    onClick={() => handleRemoveFavorite(item.id)}
                  />
                </div>
                <div className="wishlist-info">
                  <p className="wishlist-name">{item.name}</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0px 15px",
                    }}
                  >
                    <p className="wishlist-size">Size: {item.size?.name}</p>
                    <p className="wishlist-price">$ {item.size?.price}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default WishList;
